module.exports = __webpack_public_path__ + "media/images/mailer/logo_transparent-d5f79563f3d49211b0544c815a83001f.png";